module.exports = __webpack_public_path__ + "static/media/tds-charity.ef0fd94a.png";